module.exports = __webpack_public_path__ + "10d3b2d1085dfcfc8b9ef40381fac996.svg";